import { render, staticRenderFns } from "./IconFormula.vue?vue&type=template&id=9016c648&"
import script from "./IconFormula.vue?vue&type=script&lang=js&"
export * from "./IconFormula.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports